import { Tab, Tabs } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledStepperTabs = styled(Tabs)(() => ({
  "width": "100%",
  "minHeight": "52px",
  "padding": "4px",
  "borderRadius": "8px",
  "backgroundColor": "#F7F8FA",
  "boxShadow": "none",
  ".MuiTabs-indicator": {
    display: "none",
  },
}));

export const StyledStepperTab = styled(Tab)(({ theme }) => ({
  "textTransform": "none",
  "minWidth": 120,
  "fontSize": "16px",
  "minHeight": "44px",
  "height": "44px",
  "paddingLeft": "18px",
  "paddingRight": "18px",
  "borderRadius": "8px",
  "boxShadow": "none",
  "flex": "1",
  "color": "#333333",
  "backgroundColor": "transparent",
  "fontWeight": 500,

  "&.Mui-selected": {
    backgroundColor: "#FFFFFF",
    color: theme.palette.primary.main,
    fontWeight: 700,
    borderRadius: "6px",
    boxShadow: "none",
  },

  "marginBottom": 0,

  "&.Mui-focusVisible": {
    boxShadow: "none",
  },
}));
